export default prefix => async (ctx, next) => {
  if (ctx.request.prefix) {
    ctx.request.pathname = ctx.request.pathname.replace(ctx.request.prefix, '')
  }
  const parsedPrefix = `/${prefix.replace(/^\/+|\/+$/g, '')}`
  ctx.request.prefix = parsedPrefix
  ctx.request.pathname = `${parsedPrefix}/${ctx.request.pathname.replace(/^\/+/g, '')}`
  await next()
}
